import { Agreement, AgreementCharge } from 'services/resources';
import { isNull } from 'lodash';
import moment from 'moment';
import { AGREEMENT_STATUSES } from 'constants/agreements';

export const sanitizeAgreementCharge = (charge: AgreementCharge) => {
  const sanitizedCharge = { ...charge };

  delete sanitizedCharge.subtotal;

  if (isNull(sanitizedCharge.id)) {
    delete sanitizedCharge.id;
  }

  return sanitizedCharge;
};

export const sanitizeAgreementCharges = (charges: AgreementCharge[]) =>
  charges.map((agreementCharge) => {
    return sanitizeAgreementCharge(agreementCharge);
  });

export const sanitizeNewAgreement = <T extends Partial<Agreement>>(agreement: T): T => {
  const { dateDue, dateIn, dateOut, status, ...agreementRest } = agreement;

  const sanitizedAgreement = { ...agreementRest } as T;

  if (dateDue) {
    sanitizedAgreement.dateDue = moment(dateDue).toISOString();
  }

  if (dateOut) {
    sanitizedAgreement.dateOut = moment(dateOut).toISOString();
  }

  if (dateIn) {
    sanitizedAgreement.dateIn = moment(dateIn).toISOString();
  }

  sanitizedAgreement.status = status ?? AGREEMENT_STATUSES.BOOKED;

  return sanitizedAgreement;
};
